import { getRemoteConfig, fetchAndActivate, getValue, RemoteConfig } from 'firebase/remote-config';
import { app } from '../firebase';
import { logger } from '../utils/logger';

export interface MaintenanceConfig {
  maintenance_mode: boolean;
}

const DEFAULT_CONFIG: MaintenanceConfig = {
  maintenance_mode: false,
};

let remoteConfig: RemoteConfig | null = null;
let lastFetchTime = 0;
const CACHE_TTL = 25000; // 25 seconds cache TTL

export const initRemoteConfig = () => {
  if (!remoteConfig) {
    remoteConfig = getRemoteConfig(app);
    remoteConfig.settings = {
      minimumFetchIntervalMillis: 30000, // 30 seconds for quick toggle
      fetchTimeoutMillis: 10000, // 10 seconds timeout
    };
    remoteConfig.defaultConfig = {
      maintenance_mode: false,
    };
  }
  return remoteConfig;
};

export const fetchMaintenanceConfig = async (): Promise<MaintenanceConfig> => {
  try {
    const rc = initRemoteConfig();
    const now = Date.now();
    
    // Only fetch from server if cache is expired
    if (now - lastFetchTime > CACHE_TTL) {
      logger.info('🔄 [RemoteConfig] Cache expired, fetching new config from server');
      await fetchAndActivate(rc);
      lastFetchTime = now;
    } else {
      logger.info('📋 [RemoteConfig] Using cached config data');
    }
    
    // Get value from Remote Config (either cached or fresh)
    const maintenance_mode = getValue(rc, 'maintenance_mode').asBoolean();
    logger.info('🛠️ [RemoteConfig] maintenance_mode:', maintenance_mode);
    return { maintenance_mode };
  } catch (error) {
    logger.error('❌ [RemoteConfig] Failed to fetch config:', error);
    return DEFAULT_CONFIG;
  }
};
